import { useOutletContext } from 'react-router-dom';
import { ContactProfile, contactLoader } from '@enrich/shared-lib';

export const ClientContactProfile = () => {
    const user = useOutletContext();
    return (
        <ContactProfile
            showAdminActions={false}
            clientCompanyName={user?.company?.name}
            hideRaceData={!!user?.company?.hideRaceData}
        />
    );
};

export { contactLoader };
